import React from 'react'
import { Props_SnippetHeading} from './Heading.props'

const SnippetHeading = (props: Props_SnippetHeading) => (
    <section className='snippet-heading'>
        { props.snippet?.level?.value && React.createElement(props.snippet.level.value, { className: 'snippet-heading__heading' }, props.snippet?.heading?.value) }
    </section>
)

export default SnippetHeading